export function usePwaAutoUpdate() {
  onMounted(() => {
    if (!('serviceWorker' in navigator)) return

    // Listen for when the new service worker takes control
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      // Force reload to show new version
      window.location.reload()
    })
  })
}
